import React, { useState } from "react";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {
  MapPin,
  Ruler,
  Scale,
  Package,
  Truck,
} from "lucide-react";
// import DelhiveryIcon from "../../../assets/Icons/DELHIVERY.NS_BIG.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";
import { apiList } from "../../../helpers/apiList";
import { useSelector } from "react-redux";

const RateCalculator = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const dashboardData = useSelector((state) => state.balance.balance);
  const { userProfile } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    username: loggedInUserName,
    source_pincode: "",
    destination_pincode: "",
    express: "",
    shipment_length: "",
    shipment_width: "",
    shipment_height: "",
    shipment_weight: "",
    shipmentType:"",
  });

  const [errors, setErrors] = useState({});
  const [result, setResult] = useState(null);
  const [delhiveryData, setDelhiveryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dLoading, setDLoading] = useState(false);
  const [rates, setRates] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Destination Pincode field - accept only numbers and limit to 6 digits
    if (name === "source_pincode" || name === "destination_pincode") {
      // Allow only numbers
      const numericValue = value.replace(/[^0-9]/g, "");

      // Limit to 6 digits
      if (numericValue.length > 6) return;

      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));

      if (errors[name]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
      return;
    }

    // Numeric fields restriction
    const numericFields = [
      "shipment_length",
      "shipment_width",
      "shipment_height",
      "shipment_weight",
    ];

    if (numericFields.includes(name)) {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleBlurFormat = (name) => {
    if (
      [
        "shipment_length",
        "shipment_width",
        "shipment_height",
        "shipment_weight",
      ].includes(name)
    ) {
      setFormData((prev) => {
        return {
          ...prev,
          [name]: prev[name] ? parseFloat(prev[name]).toFixed(2) : "0.00",
        };
      });

      if (errors[name]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
  };

  const handleReload = () => {
    setFormData({
      username: loggedInUserName,
      source_pincode: "",
      destination_pincode: "",
      express: "",
      shipment_length: "",
      shipment_width: "",
      shipment_height: "",
      shipment_weight: "",
      shipmentType: "",
    });
    setErrors({});
    setResult(null);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.source_pincode && (userProfile === "OPERATION" || userProfile === "HUB"))
      newErrors.source_pincode = "Source pincode is required";
    if (!/^[1-9][0-9]{5}$/.test(formData.source_pincode) && (userProfile === "OPERATION" || userProfile === "HUB"))
      newErrors.source_pincode = "Enter a valid 6-digit pincode";
    if (!formData.destination_pincode)
      newErrors.destination_pincode = "Destination pincode is required";
    if (!/^[1-9][0-9]{5}$/.test(formData.destination_pincode))
      newErrors.destination_pincode = "Enter a valid 6-digit pincode";
    if (!formData.shipment_weight)
      newErrors.shipment_weight = "Shipment weight is required";
    if (!formData.shipment_length)
      newErrors.shipment_length = "Length is required";
    if (!formData.shipment_width)
      newErrors.shipment_width = "Width is required";
    if (!formData.shipment_height)
      newErrors.shipment_height = "Height is required";
    if (!formData.express) newErrors.express = "Please select Express Type";
    if (!formData.shipmentType) newErrors.shipmentType = "Shipment type is required";

    return newErrors;
  };

    
  const handleAllCarrierRateCalculator = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    // Stop if frontend validation fails
    if (Object.keys(validationErrors).length > 0) return;

    setDLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        sourcePincode: formData?.source_pincode || "400604",
        destinationPincode: formData.destination_pincode,
        weight: Number(formData.shipment_weight), // kg
        shipmentType: formData?.shipmentType || "NON_DOX",
        expressType: formData?.express === "surface" ? "SURFACE" : "AIR",
        length: Number(formData.shipment_length), // cm
        height: Number(formData.shipment_height), // cm
        breadth: Number(formData.shipment_width), // cm
      }
      const response = await axiosPostApi(
        `${apiList.ALL_CARRIER_RATE_CALCULATOR}`,
        payload
      );

      const apiData = response?.data?.data;

      // ✅ Success condition
      if (response?.data?.respCode === "00" && response?.data?.status === true) {
        const rate = apiData?.rates || [];
        setRates(rate);

         const delhiveryRate = rate.find(
           (item) => item.courier === "DELHIVERY"
         );
       
         setResult(delhiveryRate || rate[0]);
        toast.success("Rate calculated successfully!", { autoClose: 2000 });
      }
      // ⚠️ Backend validation (like COD < 1)
      else if (apiData?.status === false && apiData?.response) {
        CustomAlert({
          title: "Validation Failed",
          text: apiData.response,
          icon: "warning",
          confirmButtonText: "OK",
        });

        handleReload();
      }
      // ❌ General failure case
      else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Unable to fetch rates",
          icon: "error",
        });

        handleReload();
      }
    } catch (err) {
      CustomAlert({
        title: "Error",
        text: "Failed to fetch rate data. Please try again later.",
        icon: "error",
      });
    } finally {
      setDLoading(false);
    }
  };

  return (
    <div>
      <HeaderWithBreadcrumb title="Rate Calculator" breadcrumb="Master" />
      {/* Main Container */}
      <div className="flex bg-white rounded-2xl shadow-lg w-[85%] max-w-[1600px] overflow-hidden border border-gray-200 relative z-10">
        {/* Decorative Circles */}
        <img
          src={LeftCircle}
          alt="Left Decoration"
          className="absolute left-0 bottom-0 w-[110px] h-[105px] z-0"
        />
        <img
          src={RightCircle}
          alt="Right Decoration"
          className="absolute right-0 top-0 w-[110px] h-[105px] z-0"
        />
        {/* LEFT FORM (50%) */}

        <form onSubmit={handleAllCarrierRateCalculator} className="w-[50%] p-10 bg-white">
          <div className="grid grid-cols-2 gap-4">
            {/* Source Pincode */}
            {(userProfile === "OPERATION" || userProfile === "HUB") && 
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">
                  Source Pincode <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute left-2 top-2">
                    <MapPin size={16} className="text-[#FF6600]" />
                  </div>
                  <input
                    type="text"
                    name="source_pincode"
                    placeholder="Enter source pincode"
                    value={formData.source_pincode}
                    onChange={handleChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength="6"
                    className={`w-full h-[36px] rounded-md border ${
                      errors.source_pincode ? "border-red-400" : "border-gray-300"
                    } pl-8 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6focus:outline-none bg-white placeholder-gray-400 text-left`}
                  />
                </div>
                {errors.source_pincode && (
                  <p className="text-red-500 text-[12px] mt-1">
                    {errors.source_pincode}
                  </p>
                )}
              </div>
            }

            {/* Destination Pincode */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Destination Pincode <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div className="absolute left-2 top-2">
                  <MapPin size={16} className="text-[#FF6600]" />
                </div>
                <input
                  type="text"
                  name="destination_pincode"
                  placeholder="Enter destination pincode"
                  value={formData.destination_pincode}
                  onChange={handleChange}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength="6"
                  className={`w-full h-[36px] rounded-md border ${
                    errors.destination_pincode
                      ? "border-red-400"
                      : "border-gray-300"
                  } pl-8 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white placeholder-gray-400 text-left`}
                />
              </div>
              {errors.destination_pincode && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.destination_pincode}
                </p>
              )}
            </div>

            {/* Shipment Weight */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Shipment Weight <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <div className="relative flex-1">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2">
                    <Scale size={16} className="text-[#FF6600]" />
                  </span>
                  <input
                    type="text"
                    name="shipment_weight"
                    placeholder="Enter weight"
                    value={formData.shipment_weight}
                    onChange={handleChange}
                    onBlur={() => handleBlurFormat("shipment_weight")}
                    className={`w-full h-[36px] rounded-md border ${
                      errors.shipment_weight
                        ? "border-red-400"
                        : "border-gray-300"
                    } pl-8 pr-2 text-[15px] text-left focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white placeholder-gray-400`}
                    style={{
                      textAlign: formData.shipment_weight ? "right" : "left",
                    }}
                  />
                </div>
                <div className="bg-[#2e237f] text-white text-[13px] font-medium h-[36px] px-3 flex items-center justify-center rounded-r-md">
                  kg
                </div>
              </div>
              {errors.shipment_weight && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.shipment_weight}
                </p>
              )}
            </div>

            {/* Length */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Length <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <div className="relative flex-1">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2">
                    <Ruler size={16} className="text-[#FF6600]" />
                  </span>
                  <input
                    type="text"
                    name="shipment_length"
                    placeholder="Enter length"
                    value={formData.shipment_length}
                    onChange={handleChange}
                    onBlur={() => handleBlurFormat("shipment_length")}
                    className={`w-full h-[36px] rounded-md border ${
                      errors.shipment_length
                        ? "border-red-400"
                        : "border-gray-300"
                    } pl-8 pr-2 text-[15px] text-left focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white placeholder-gray-400`}
                    style={{
                      textAlign: formData.shipment_length ? "right" : "left",
                    }}
                  />
                </div>
                <div className="bg-[#2e237f] text-white text-[13px] font-medium h-[36px] px-3 flex items-center justify-center rounded-r-md">
                  cm
                </div>
              </div>
              {errors.shipment_length && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.shipment_length}
                </p>
              )}
            </div>

            {/* Width */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Width <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <div className="relative flex-1">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2">
                    <Package size={16} className="text-[#FF6600]" />
                  </span>
                  <input
                    type="text"
                    name="shipment_width"
                    placeholder="Enter width"
                    value={formData.shipment_width}
                    onChange={handleChange}
                    onBlur={() => handleBlurFormat("shipment_width")}
                    className={`w-full h-[36px] rounded-md border ${
                      errors.shipment_width
                        ? "border-red-400"
                        : "border-gray-300"
                    } pl-8 pr-2 text-[15px] text-left focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white placeholder-gray-400`}
                    style={{
                      textAlign: formData.shipment_width ? "right" : "left",
                    }}
                  />
                </div>
                <div className="bg-[#2e237f] text-white text-[13px] font-medium h-[36px] px-3 flex items-center justify-center rounded-r-md">
                  cm
                </div>
              </div>
              {errors.shipment_width && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.shipment_width}
                </p>
              )}
            </div>

            {/* Height */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Height <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <div className="relative flex-1">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2">
                    <Ruler size={16} className="text-[#FF6600]" />
                  </span>
                  <input
                    type="text"
                    name="shipment_height"
                    placeholder="Enter height"
                    value={formData.shipment_height}
                    onChange={handleChange}
                    onBlur={() => handleBlurFormat("shipment_height")}
                    className={`w-full h-[36px] rounded-md border ${
                      errors.shipment_height
                        ? "border-red-400"
                        : "border-gray-300"
                    } pl-8 pr-2 text-[15px] text-left focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white placeholder-gray-400`}
                    style={{
                      textAlign: formData.shipment_height ? "right" : "left",
                    }}
                  />
                </div>
                <div className="bg-[#2e237f] text-white text-[13px] font-medium h-[36px] px-3 flex items-center justify-center rounded-r-md">
                  cm
                </div>
              </div>
              {errors.shipment_height && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.shipment_height}
                </p>
              )}
            </div>

            {/* Shipment Type */}
            <div>
              {/* <label className="text-xs font-medium text-gray-700 mb-1 block">
                Payment Mode
              </label>
              <div className="relative">
                <div className="absolute left-2 top-2">
                  <CreditCard size={16} className="text-[#FF6600]" />
                </div>
                <input
                  type="text"
                  name="payment_mode"
                  value={formData.payment_mode}
                  disabled
                  className="w-full h-[36px] rounded-md border border-gray-300 pl-8 pr-2 text-[15px] bg-gray-100 text-gray-800 cursor-not-allowed"
                />
              </div> */}

              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Shipment Type <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div className="absolute left-2 top-2">
                  <Truck size={16} className="text-[#FF6600]" />
                </div>
                <select
                  name="shipmentType"
                  value={formData.shipmentType}
                  onChange={handleChange}
                  className={`w-full h-[36px] rounded-md border ${
                    errors.shipmentType ? "border-red-400" : "border-gray-300"
                  } pl-8 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white text-left text-gray-800`}
                  style={{
                    textAlignLast: "left",
                    paddingLeft: "32px",
                  }}
                >
                  <option value="">Select Shipment Type</option>
                  <option value="NON_DOX">Non Doc</option>
                  <option value="DOX">Doc</option>
                </select>
              </div>
              {errors.shipmentType && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.shipmentType}
                </p>
              )}

            </div>

            {/* Express Type */}
            <div>
              <label className="text-xs font-medium text-gray-700 mb-1 block">
                Express Type <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div className="absolute left-2 top-2">
                  <Truck size={16} className="text-[#FF6600]" />
                </div>
                <select
                  name="express"
                  value={formData.express}
                  onChange={handleChange}
                  className={`w-full h-[36px] rounded-md border ${
                    errors.express ? "border-red-400" : "border-gray-300"
                  } pl-8 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none bg-white text-left text-gray-800`}
                  style={{
                    textAlignLast: "left",
                    paddingLeft: "32px",
                  }}
                >
                  <option value="">Select Express Type</option>
                  <option value="surface">Surface</option>
                  <option value="air">Air</option>
                </select>
              </div>
              {errors.express && (
                <p className="text-red-500 text-[12px] mt-1">
                  {errors.express}
                </p>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="col-span-2 flex justify-center gap-4 mt-8">
            {/* Reload Button */}
            <button
              type="button"
              onClick={handleReload}
              className="btn btn-submit !rounded-[8px] w-[133px] h[33px]"
            >
              Reload
            </button>

            {/* Get Charges Button */}
            <button
              type="submit"
              disabled={loading}
              className={`btn btn-submit !rounded-[8px] w-[133px] h[33px] ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#FF6600] hover:bg-[#e25b00] shadow-md"
              }`}
            >
              {loading ? "Loading..." : "Get Charges"}
            </button>
          </div>
        </form>

        {/* RIGHT RESULT (50%) */}
        <div className="w-[50%] bg-[#FFF5EB] p-12 rounded-l-none rounded-r-2xl border-l border-yellow-300 shadow-inner">
          {rates?.length === 0 ? (
            <div className="flex items-center justify-center h-full text-gray-600 text-lg font-medium">
              Fill details and click{" "}
              <strong className="ml-1 text-[#FF6600]">Get Charges</strong>
            </div>
          ) : (
            <div className="space-y-8 text-gray-900">
              {/* Header Row */}
              <div className="flex justify-between items-start">
                {/* Source */}
                <div>
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
                    Source
                  </p>
                  <p className="text-[#00A651] font-bold text-[18px] leading-tight">
                    {result?.sourcePincode || "N/A"}
                  </p>
                  <p className="text-[14px] text-gray-700 font-medium">
                    {result?.sourceLocation || "N/A"}
                  </p>
                </div>

                {/* Truck Icon */}
                <div className="flex justify-center items-center bg-white rounded-full p-3 shadow-md">
                  <Truck className="text-[#FF6600]" size={44} />
                </div>

                {/* Destination */}
                <div className="text-right">
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
                    Destination
                  </p>
                  <p className="text-[#00A651] font-bold text-[18px] leading-tight">
                    {result?.destinationPincode || "N/A"}
                  </p>
                  <p className="text-[14px] text-gray-700 font-medium">
                    {result?.destinationLocation || "N/A"}
                  </p>
                </div>
              </div>

              {/* Weight Summary */}
              {/* <div className="flex justify-between text-[15px] border-b border-gray-300 pb-3">
                <div>
                  <p className="font-semibold text-gray-700">Billing Weight</p>
                  <p className="text-[15px] font-bold text-gray-900">
                    {result.charged_weight} {result.weight_unit}
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-gray-700">Base Weight</p>
                  <p className="text-[15px] font-bold text-gray-900">
                    {result.base_weight} {result.weight_unit}
                  </p>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-gray-700">
                    Additional Weight
                  </p>
                  <p className="text-[15px] font-bold text-gray-900">
                    {result.additional_weight} {result.weight_unit}
                  </p>
                </div>
              </div> */}

              {/* Note */}
              {/* <p className="text-[13px] text-gray-500 mt-3 italic">
                {result.note}
              </p> */}

              {/* Header Row */}
              <div className="grid grid-cols-12 text-[13px] text-gray-500 font-semibold mb-2 uppercase border-b border-gray-300">
                <p className="col-span-3 pl-10">Courier</p>
                <p className="col-span-2 text-center">Service</p>
                <p className="col-span-2 text-center">Shipping</p>
                <p className="col-span-2 text-center">Fuel</p>
                <p className="col-span-1 text-center">GST</p>
                <p className="col-span-2 text-right pr-3">Total</p>
              </div>

              {/* Body */}
              {rates.map((item, index) => (
                <div
                  key={index}
                  className="grid grid-cols-12 items-center bg-white rounded-xl shadow-sm py-3 hover:shadow-md transition-all mt-3 border border-orange-200"
                >
                {/* Courier */}
                <div className="col-span-3 flex items-center justify-center font-semibold">
                  {item.courier === "DELCAPER" ? "SHREE MARUTI" : item.courier}
                </div>

                {/* Service Type */}
                <div className="col-span-2 text-center text-[14px] text-gray-700">
                  {item.serviceType}
                </div>

                {/* Shipping */}
                <div className="col-span-2 text-center text-[14px] text-gray-700">
                  ₹ {item.shippingCharges}
                </div>

                {/* Fuel */}
                <div className="col-span-2 text-center text-[14px] text-gray-700">
                  ₹ {item.fuelCharges}
                </div>

                {/* GST */}
                <div className="col-span-1 text-center text-[14px] text-gray-700">
                  ₹ {item.gstAmount}
                </div>

                {/* Total */}
                <div className="col-span-2 text-right pr-3 font-bold text-[15px] text-gray-900">
                  ₹ {item.totalAmount}
                </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RateCalculator;
